import * as PIXI from 'pixi.js';
import SoundManager from 'Engine/soundManager/SoundManager';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import EntryPoint from 'Engine/EntryPoint';
import { eSounds } from '../enums/eSounds';
import FlashLib from 'flashlib_onlyplay';
import eSymbolIndex from '../symbols/eSymbolIndex';
import eEventTypes from '../enums/eEventTypes';
import ControllerFeatures from '../slot/features/ControllerFeatures';
import eAnimationTypes from '../enums/eAnimationTypes';
import { eAnimationNames } from '../enums/eAnimationNames';
import eGameMode from '../enums/eGameMode';

export default class ReelsContainer extends FlashLib.MovieClip {
  constructor(data, displayItemData) {
    super(data, displayItemData);

    this._freespinsTriggerIds = [eSymbolIndex.ESI_SCATTER];
    this._swapReelsHandlers = {
      [eGameMode.EGM_REGULAR]: this._setMainGameReels.bind(this),
      [eGameMode.EGM_BONUS]: this._setBonusGameReels.bind(this),
    };

    this.init();
    // this.initFeaturesController();
    this.addListeners();
    this.initReels();
    this._activateMask(false);
  }

  init() {
    this._stopSoundPlayed = false;
    this._scatterSoundPlayed = false;
    this.hasScatter = false;
    this._scatterSymbols = [];

    this.wrapper = this.getChildByName('wrapper');
    this.ControllerReels = this.wrapper.getChildByName('controllerReels');
    this.waysPanel = this.getChildByName('waysPanel');

    this._createMask();
  }

  initReels() {
    this.ControllerReels.hideBottomSymbols = false;
    const megawaysAvailableReels = this.createMegawaysAvailableReels(EntryPoint.configData.reels.availableReelsNormal)
    this.ControllerReels.init(megawaysAvailableReels);
    this.ControllerReels.bottomSimbolsCount = 0;
    this.ControllerReels.reels.forEach((reel) => {
      reel.symbols[0].visible = false;
      this.waysPanel.multiply(reel.symbols[1].children.length)
    })
  }

  createMegawaysAvailableReels(availableReels) {
    let megawaysAvailableReels = availableReels.map(reelData => reelData.map(symbolIndex => symbolIndex));
    const weights = EntryPoint.configData.reels.symbolsHeightsData.weights;
    const heights = EntryPoint.configData.reels.symbolsHeightsData.heights;
    const availableHeights = [];
    heights.forEach((height, index) => {
      for (let i = 0; i < weights[index]; i++) {
        availableHeights.push(height);
      }
    })

    megawaysAvailableReels = megawaysAvailableReels.map(reelData => {
      const newReelData = [];
      let symbolIndex = reelData.pop();
      let randomHeight = availableHeights[Math.floor(availableHeights.length * Math.random())];
      let step = randomHeight;
      let symbolsBlock = [];

      while (typeof symbolIndex === 'number') {
        if (step === 0)  {
          newReelData.push(symbolsBlock);
          randomHeight = availableHeights[Math.floor(availableHeights.length * Math.random())];
          step = randomHeight;
          symbolsBlock = [];
        }
        symbolsBlock.push(symbolIndex);
        step--
        symbolIndex = reelData.pop();
      }
      return newReelData;
    });

    return megawaysAvailableReels;
  }

  initFeaturesController(container) {
    this.ControllerFeatures = new ControllerFeatures({ topContainer: container, reelsContainer: this, controllerReels: this.ControllerReels });
  }

  addListeners() {
    this.ControllerReels.onHittingBar = this.onHitBar.bind(this);
    this.ControllerReels.onAllReelsStopped = this.onAllReelsStopped.bind(this);
    GlobalDispatcher.add(eEventTypes.EET_FREESPIN_IN_STATE__START, this.onStartBonusGameInState, this);
  }

  show() {
    this.visible = true;
  }

  hide() {
    this.visible = false;
    this.stopAnimations();
  }

  swapReels(mode) {
    this.ControllerFeatures.reset();
    this._swapReelsHandlers[mode]();
  }

  onHitBar(reelIndex) {
    if(reelIndex === 1) GlobalDispatcher.dispatch(eEventTypes.EET_FOURTH_REEL_STOPPED);

    this.ControllerFeatures.onReelHitBar(reelIndex);
    this.waysPanel.multiply(this.data[reelIndex][0].length);


    const symbols = this.ControllerReels.reels[reelIndex].symbols[1].symbols;
    for (let i = 0; i <= symbols.length - 1; i++) {
      const symbol = symbols[i];
      if (this._freespinsTriggerIds.includes(symbol.id)) {
        this.hasScatter = true;
        this._scatterSymbols.push(symbol);
        // symbol.startStopAnimation();
      }
    }

    this.playStopSound();
  }

  playStopSound() {
    if (!this._stopSoundPlayed) {
      SoundManager.play(eSounds.EST_REEL_STOP.soundName, eSounds.EST_REEL_STOP.volume + 0.2 * Math.random(), false, eSounds.EST_REEL_STOP.group);
      this._stopSoundPlayed = EntryPoint.GameSettings.quickStop;
    }

    if (this.hasScatter) {
      this.hasScatter = false;
      if (!this._scatterSoundPlayed) {
        SoundManager.play(eSounds.EST_SCATTER_STOP.soundName, eSounds.EST_SCATTER_STOP.volume + 0.2 * Math.random(), false, eSounds.EST_SCATTER_STOP.group);
        this._scatterSoundPlayed = EntryPoint.GameSettings.quickStop;
      }
    }
  }

  onAllReelsStopped() {
    this._activateMask(false);
    GlobalDispatcher.dispatch(eEventTypes.EET_REELS_STOPPED);
  }

  onStartBonusGameInState() {
    if (!this.willShowScattersAnimation) return;
    this.ControllerFeatures.showBonusGameStart(this._scatterSymbols);
  }

  start() {
    this.waysPanel.reset();
    this.ControllerFeatures.reset();
    this._activateMask(true);
    this._stopSoundPlayed = false;
    this._scatterSoundPlayed = false;
    this._scatterSymbols = [];
    const config = this._getReelsStartConfig();
    Object.assign(this.ControllerReels, config);
    this.ControllerReels.start();
  }

  stop(data) {
    // data = [[6, 6], [6, 4, 3, 6, 4, 3], [5, 1, 2, 1, 2], [5, 1, 2, 1], [1, 2, 1], [2, 1]]
    data = data.map(reelData => [reelData]);
    this.data = data;
    const config = this._getReelsStopConfig();
    const symbolsCountForStop = this._getSymbolsCountForStop(this.data, config);
    Object.assign(this.ControllerReels, config, { symbolsCountForStop });
    this.ControllerReels.stop(this.data);
  }

  startWinnings(data) {
    this.ControllerFeatures.startWinnings(data);
  }

  showWin(data) {
    this.ControllerFeatures.showWin(data);
  }

  stopAnimations() {
    this.ControllerReels.reels.forEach(reel => reel.symbols.forEach(symbol => symbol.stopAnimation()));
  }

  _getSymbolsCountForStop(data, config) {
    let currentValues = config.hasOwnProperty('symbolsCountForStop') ? config.symbolsCountForStop : this.ControllerReels.symbolsCountForStop;

    const newValues = [];
    for (let i = 0; i < this.ControllerReels.reels.length; i++) {
      let value = this.ControllerReels.getConfigValue(currentValues, i);
      newValues.push(value);
    }

    return newValues;
  }

  _getReelsConfig() {
    let config = EntryPoint.configData.reels.config;
    return EntryPoint.GameModel.freespinsEnabled ? config.freeSpins : config.regularSpins;
  }

  _getReelsStopConfig() {
    const config = this._getReelsConfig();
    return (EntryPoint.GameSettings.quickStop || EntryPoint.GameSettings.quickSpin) ? config.quick.stop : config.default.stop;
  }

  _getReelsStartConfig() {
    const config = this._getReelsConfig();
    return EntryPoint.GameSettings.quickSpin ? config.quick.start : config.default.start;
  }

  _setBonusGameReels() {
    this.ControllerReels.setAvailableSymbols(EntryPoint.GameModel.freespinsAvalibleReels);
    this._lastReelsMainGame = this.ControllerReels.reels.map(reel => reel.symbols.map(symbol => symbol.id))
  }

  _setMainGameReels() {
    this.ControllerReels.setAvailableSymbols(EntryPoint.configData.reels.availableReelsNormal);
    if (this._lastReelsMainGame) {
      this._lastReelsMainGame.forEach((reel, reelIndex) => {
        reel.forEach((symbolId, symbolIndex) => {
          const symbol = this.ControllerReels.reels[reelIndex].symbols[symbolIndex];
          symbol.changeSymbol(symbolId);
        })
      })
    }
  }

  _createMask() {
    this.reelsMask = new PIXI.Graphics();
    this.reelsMask.beginFill(0xFF3300);
    this.reelsMask.drawRect(0, 0, 1650, 764);
    this.reelsMask.endFill()
    this.addChild(this.reelsMask);
    this.reelsMask.visible = false
  }

  _activateMask(value) {
    this.wrapper.mask = value ? this.reelsMask : null;
    this.reelsMask.visible = value
    this._setVisibleOnTopAndButtonSymbols(value);
  }

  _setVisibleOnTopAndButtonSymbols(visible) {
    this.ControllerReels.reels.forEach((reel) => {
      reel.symbols.forEach((symbol, index) => {
        if (index < this.ControllerReels.topSimbolsCount || index > (reel.symbols .length - 1 - this.ControllerReels.bottomSimbolsCount)) {
          symbol.visible = visible;
        }
      })
    })
  }

  get willShowScattersAnimation() {
    return this._scatterSymbols.length;
  }
}
